import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const LateNeonatalMortality = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Mortalidade Neonatal Tardia - de 7 a 27 dias de vida'}
            indicatorValue={chartData?.indicators?.lateNeonatalMortality}
            className="aligned-container"
            goalValue={1}
            goalMessage="Meta Aceitável - 10 a cada 1000"
        />
    );
};
